module.exports = __webpack_public_path__ + "img/research_2.27e0c56d.png";